
export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  vessel: {
    label: {
      color: 'grey-darkest',
      fontWeight: 'semibold',
      fontSize: 'xs'
    }
  },
  computed: {
    taxonName() {
      return this.product.category[0].name
    },
    taxonPath() {
      const slug = this.product.category[0].slug
      const route = { name: 'categories-id', params: { id: slug } }

      return this.$pagePath(route)
    }
  }
}
